import { create } from 'zustand';

export interface Toast {
  id: string;
  type: 'success' | 'error' | 'info';
  message: string;
  duration: number;
}

export interface ToastStore {
  toasts: Toast[];
  addToast: (toast: Omit<Toast, 'id'>) => void;
  removeToast: (id: string) => void;
}

const MAX_VISIBLE_TOASTS = 3;

let toastCounter = 0;

function generateToastId(): string {
  toastCounter += 1;
  return `toast-${Date.now()}-${toastCounter}`;
}

export const useToastStore = create<ToastStore>((set) => ({
  toasts: [],

  addToast: (toast: Omit<Toast, 'id'>) => {
    const id = generateToastId();
    const newToast: Toast = { ...toast, id };

    set((state) => {
      const updatedToasts = [...state.toasts, newToast];
      // Keep only the most recent MAX_VISIBLE_TOASTS toasts visible
      if (updatedToasts.length > MAX_VISIBLE_TOASTS) {
        return { toasts: updatedToasts.slice(-MAX_VISIBLE_TOASTS) };
      }
      return { toasts: updatedToasts };
    });
  },

  removeToast: (id: string) =>
    set((state) => ({
      toasts: state.toasts.filter((t) => t.id !== id),
    })),
}));
